import { Profile } from "../shared/profile.model";
import { Community } from "../communities/community.model";
import { PanelMember } from "./panel-member.model";

export class Discussion {
  slug: string;
  title: string = "";
  description: string = "";
  body: string = "";
  community: Community;
  commentCount: number;
  upVoteCount: number;
  downVoteCount: number;
  bookmarkCount: number;
  author: Profile;
  image: string;
  voted: {
    upVote: boolean;
    downVote: boolean;
  };
  tagList: Array<string> = [];
  panel: Array<PanelMember> = [];
  bookmarked: boolean;
  createdAt: string;
  updatedAt: string;
}
